// Shared by the service-worker listener and the version notice. Updating the
// worker must never navigate the page or end a lesson.
// This event requests a version check; a worker change alone is not proof that
// the loaded page is outdated.
export const APP_UPDATE_AVAILABLE_EVENT = "chickytutor:update-available";
